var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-16"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.78,
    y: 156.48,
    width: 176.29,
    height: 223.23,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.01,
    y: 164.62,
    width: 163.83,
    height: 47.74,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.01,
    y: 172.34,
    width: 9.31,
    height: 40.01,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.01,
    y: 172.34,
    width: 9.31,
    height: 40.01,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.56,
    y: 171.85,
    width: 9.31,
    height: 40.01,
    transform: "matrix(0.99, -0.17, 0.17, 0.99, -27.12, 66.68)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.54,
    y: 177.62,
    width: 9.31,
    height: 34.74,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.94,
    y: 177.62,
    width: 9.31,
    height: 34.74,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.93,
    y: 177.62,
    width: 9.31,
    height: 34.74,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.12,
    y: 177.02,
    width: 9.31,
    height: 34.74,
    transform: "translate(-34.12 77.89) rotate(-12.53)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.25,
    y: 170.36,
    width: 4.65,
    height: 41.99,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.6,
    y: 170.36,
    width: 4.65,
    height: 41.99,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.01,
    y: 219.91,
    width: 163.83,
    height: 47.74,
    transform: "translate(707.85 487.56) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.53,
    y: 227.64,
    width: 9.31,
    height: 40.01,
    transform: "translate(862.37 495.29) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.53,
    y: 227.64,
    width: 9.31,
    height: 40.01,
    transform: "translate(772.37 495.29) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.98,
    y: 227.14,
    width: 9.31,
    height: 40.01,
    transform: "translate(616.48 547.02) rotate(-170.22)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 232.91,
    width: 9.31,
    height: 34.74,
    transform: "translate(839.31 500.56) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.61,
    y: 232.91,
    width: 9.31,
    height: 34.74,
    transform: "translate(796.53 500.56) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.62,
    y: 232.91,
    width: 9.31,
    height: 34.74,
    transform: "translate(688.54 500.56) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.43,
    y: 232.32,
    width: 9.31,
    height: 34.74,
    transform: "matrix(-0.98, -0.22, 0.22, -0.98, 677.2, 573.69)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.95,
    y: 225.65,
    width: 4.65,
    height: 41.99,
    transform: "translate(818.56 493.3) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.6,
    y: 225.65,
    width: 4.65,
    height: 41.99,
    transform: "translate(707.85 493.3) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.01,
    y: 227.64,
    width: 9.31,
    height: 40.01,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.54,
    y: 232.91,
    width: 9.31,
    height: 34.74,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.94,
    y: 232.91,
    width: 9.31,
    height: 34.74,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.25,
    y: 225.65,
    width: 4.65,
    height: 41.99,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.01,
    y: 275.21,
    width: 163.83,
    height: 47.74,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.04,
    y: 282.93,
    width: 9.31,
    height: 40.01,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.6,
    y: 282.43,
    width: 9.31,
    height: 40.01,
    transform: "translate(-45.19 76.62) rotate(-9.78)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.58,
    y: 288.21,
    width: 9.31,
    height: 34.74,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.97,
    y: 288.21,
    width: 9.31,
    height: 34.74,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.96,
    y: 288.21,
    width: 9.31,
    height: 34.74,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.15,
    y: 287.61,
    width: 9.31,
    height: 34.74,
    transform: "translate(-56.94 91.16) rotate(-12.53)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.28,
    y: 280.95,
    width: 4.65,
    height: 41.99,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.63,
    y: 280.95,
    width: 4.65,
    height: 41.99,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.53,
    y: 282.43,
    width: 9.31,
    height: 40.01,
    transform: "translate(-46.74 58.43) rotate(-9.78)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.89,
    y: 288.21,
    width: 9.31,
    height: 34.74,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.08,
    y: 287.61,
    width: 9.31,
    height: 34.74,
    transform: "translate(-59.49 67.94) rotate(-12.53)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.56,
    y: 280.95,
    width: 4.65,
    height: 41.99,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.15,
    y: 173.62,
    width: 27.53,
    height: 38.96,
    transform: "translate(253.84 386.21) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.95,
    y: 175.46,
    width: 23.94,
    height: 35.3,
    transform: "translate(253.84 386.21) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.56,
    y: 160.11,
    width: 27.53,
    height: 38.96,
    transform: "translate(184.66 359.19) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.36,
    y: 161.95,
    width: 23.94,
    height: 35.3,
    transform: "translate(184.66 359.19) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.3,
    y: 136.3,
    width: 24.79,
    height: 35.08,
    transform: "translate(-23.14 284.53) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.91,
    y: 137.95,
    width: 21.56,
    height: 31.78,
    transform: "translate(-23.14 284.53) rotate(-90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.85,
    y: 121.62,
    width: 27.53,
    height: 38.96,
    transform: "translate(-54.49 227.72) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.65,
    y: 123.46,
    width: 23.94,
    height: 35.3,
    transform: "translate(-54.49 227.72) rotate(-90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.15,
    y: 102.52,
    width: 21.56,
    height: 30.51,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.56,
    y: 103.95,
    width: 18.75,
    height: 27.64,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-16"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-16",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.48,380.19s-7.68-15,1.1-29.86S421.9,332,416.3,329s-8.16,11.86-8.16,11.86-4.72-10.24-.82-21,6.34-28.2,1-30.07-1,21.79-5.64,29.86c0,0-3.87-9-4.51-17.6s.36-22.37-3.84-25.9-6.9-1.08-2.77,17.93a179,179,0,0,1,4.1,34.47s-9.12-24.94-15.24-25.67-6.11,7.35-.87,14.35,15.34,19.56,17,26c0,0-10-18.77-19-13s7.84,17.09,15.35,21.18,12.71,29.78,12.71,29.78Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.48,380.19s-7.68-15,1.1-29.86S421.9,332,416.3,329s-8.16,11.86-8.16,11.86-4.72-10.24-.82-21,6.34-28.2,1-30.07-1,21.79-5.64,29.86c0,0-3.87-9-4.51-17.6s.36-22.37-3.84-25.9-6.9-1.08-2.77,17.93a179,179,0,0,1,4.1,34.47s-9.12-24.94-15.24-25.67-6.11,7.35-.87,14.35,15.34,19.56,17,26c0,0-10-18.77-19-13s7.84,17.09,15.35,21.18,12.71,29.78,12.71,29.78Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.41,386.36s7.49-15.14-1.49-29.85-11.57-18.16-6-21.27S404.23,347,404.23,347s4.58-10.31.54-21-6.71-28.1-1.42-30.05,1.31,21.78,6,29.78c0,0,3.76-9,4.28-17.65s-.66-22.37,3.5-25.95,6.87-1.18,3,17.89a179.54,179.54,0,0,0-3.64,34.51s8.79-25.06,14.9-25.86,6.21,7.26,1.06,14.34-15.08,19.75-16.65,26.23c0,0,9.76-18.9,18.84-13.27s-7.61,17.2-15.06,21.39-12.32,29.94-12.32,29.94Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.41,386.36s7.49-15.14-1.49-29.85-11.57-18.16-6-21.27S404.23,347,404.23,347s4.58-10.31.54-21-6.71-28.1-1.42-30.05,1.31,21.78,6,29.78c0,0,3.76-9,4.28-17.65s-.66-22.37,3.5-25.95,6.87-1.18,3,17.89a179.54,179.54,0,0,0-3.64,34.51s8.79-25.06,14.9-25.86,6.21,7.26,1.06,14.34-15.08,19.75-16.65,26.23c0,0,9.76-18.9,18.84-13.27s-7.61,17.2-15.06,21.39-12.32,29.94-12.32,29.94Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.93 375.57 376.11 375.57 381.11 415.25 432.93 415.25 437.93 375.57",
    style: {
      fill: "#2DAF8E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sofa--inject-16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.45,
    y: 393.49,
    width: 187.5,
    height: 21.75,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.45,
    y: 393.49,
    width: 187.5,
    height: 21.75,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.81,
    y: 393.49,
    width: 109.13,
    height: 21.75,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.5,
    y: 393.49,
    width: 187.5,
    height: 21.75,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.5,
    y: 393.49,
    width: 187.5,
    height: 21.75,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.87,
    y: 393.49,
    width: 109.13,
    height: 21.75,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 348,
    width: 209,
    height: 51,
    rx: 8.64,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 348,
    width: 129,
    height: 51,
    rx: 8.64,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 348,
    width: 209,
    height: 51,
    rx: 8.64,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 348,
    width: 209,
    height: 51,
    rx: 8.64,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 348,
    width: 129,
    height: 51,
    rx: 8.64,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 348,
    width: 209,
    height: 51,
    rx: 8.64,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.65,349.18h-123L47.92,252.4A17.15,17.15,0,0,1,64.75,232h88.06a17.15,17.15,0,0,1,16.83,13.89Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.59,349.18H66.66L47.92,252.4A17.15,17.15,0,0,1,64.75,232h0a17.16,17.16,0,0,1,16.84,13.89Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.65,349.18h-123L47.92,252.4A17.15,17.15,0,0,1,64.75,232h88.06a17.15,17.15,0,0,1,16.83,13.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.59,349.18H66.66L47.92,252.4A17.15,17.15,0,0,1,64.75,232h0a17.16,17.16,0,0,1,16.84,13.89Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M189.65,349H101.59l-20-103.21A17.07,17.07,0,0,0,64.75,232h88.06a17.07,17.07,0,0,1,16.83,13.8Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character-1--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.86,248.37c8.14,1.8,7.26,28.48,13.56,35.63,4.55,5.17,22.08,6.5,25.75,9.83s0,9.83,0,9.83-30.24-.68-37.71-4.09S153.86,248.37,153.86,248.37Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.86,248.37c8.14,1.8,7.26,28.48,13.56,35.63,4.55,5.17,22.08,6.5,25.75,9.83s0,9.83,0,9.83-30.24-.68-37.71-4.09S153.86,248.37,153.86,248.37Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.43,324.45c-.1.17-.21.24-.33.22-3.48-.63-12.82,4.48-24.18,10.38l-3.19,1.64-1.09.55c-5.73,2.93-11.82,5.89-17.84,8.31-7.09,2.87-14.08,5-20.23,5.46-.84.07-1.65.1-2.45.1-27.63,0-18.63-45.59-18.63-45.59l33-2.53,3.89,6.71,2.11,3.63,4.76-1.28c2.39-.64,5.95-1.47,10-2.34l1-.21c1.37-.29,2.8-.58,4.26-.87,10.77-2.18,23.13-4.29,27.71-4.32C212.48,304.29,211.91,322.28,210.43,324.45Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.93,308l6.4,31.72s-22,17.91-41,10.92-13-39.26-13-39.26l25-7.66,6.84,8.16Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.33,339.67a7.78,7.78,0,0,0-1.06.69A89.64,89.64,0,0,1,168.85,348h0c-7.37,3-16.59,5.59-25.27,2.89-.42-.13-.83-.21-1.24-.36-19-7-13-39.23-13-39.23l25-7.64,5,6,1.79,2.14L176,308.18l.93-.23.31,1.55,2.8,13.88,2.69,13.31Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.83 307.33 182.5 341.67 186.5 338.51 181.17 306.67 175.83 307.33",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.5 338.51 182.5 341.67 182.27 340.48 181.64 337.24 178.93 323.28 176.29 309.71 176 308.18 175.83 307.33 181.17 306.67 181.5 308.63 184 323.57 185.92 335.05 186.5 338.51",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.43,324.45c-.1.17-.21.24-.33.22-3.48-.63-12.82,4.48-24.18,10.38l.58,3.46-4,3.16-.23-1.31A89.64,89.64,0,0,1,168.85,348h0l-5-2.57-7.3-3.82,3-27.28,4.33,6s10.1,2.45,15.1,2.93l1.11.11c1.37.11,2.71.19,4,.2.88,0,1.71,0,2.5-.07C195.1,322.9,204.4,322.58,210.43,324.45Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.86,342.86l-.31,6.61-.77,0c-1,.06-2.82.15-5.33.27-14.17.65-49.3,1.89-64.28-1.11L140.33,350l15.13-26.5,94.63,14.73,29.13,4.53Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.23,335c-.12,2.58-.22,4.91-.32,7.06-.14,2.94-.25,5.56-.37,8.06-.2,4.35-3.77,1.46-11.49.93-.19,0-.26-.63-.27-1.53,0-1.93.28-5.19.44-6.75,0-.55.09-.89.09-.89a35.21,35.21,0,0,0,2.68-2.78,22.71,22.71,0,0,0,4.83-8C288.36,325.67,291.5,328.88,291.23,335Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.25,325.5l-7.75,27.07-15.24-1.46s-39.45,15.06-29-44.4L153.5,301l8.63,20.75Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.25,325.5l-7.75,27.07-15.24-1.46s-39.45,15.06-29-44.4L153.5,301l8.63,20.75Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.58 324.02 163.83 353 169 353 176.67 325.5 172.58 324.02",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.58 324.02 163.83 353 169 353 176.67 325.5 172.58 324.02",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.91,342.05c-.14,2.94-.25,5.56-.37,8.06-.2,4.35-3.77,1.46-11.49.93-.19,0-.26-.63-.27-1.53-1,.06-2.82.15-5.33.27-7.3-4.11-17.52-8.89-23.36-11.55l29.13,4.53c0-.55.09-.89.09-.89a35.21,35.21,0,0,0,2.68-2.78Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.21,304.31c-1.2,0-.38,20.13.89,20.36,5.37,1,78.64,22.59,78.64,22.59l2.14-6.41S221.22,304.25,209.21,304.31Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.87,348.5c-.7-.25,2.75-8.76,2.75-8.76s7.22-3.54,10.17-8.33,5.1-.84,3.17,5-3.41,10.24-4.78,14.37S295.15,351.11,287.87,348.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.5,307.67l2.67,4.16S132.5,346,125.67,348c0,0-3.86-3.24-3.76-10.95S158.5,307.67,158.5,307.67Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.5,307.67l2.67,4.16S132.5,346,125.67,348c0,0-3.86-3.24-3.76-10.95S158.5,307.67,158.5,307.67Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.91,210.75a11.48,11.48,0,0,1,4.84,9.8c-.25,6.58-1.61,16.77,0,20.48s-4.16,4.74-4.16,4.74a5,5,0,0,0,0-3.11s0,1.72-2.3,2.34-20.67,1.08-24.8-2.34,4.5-31,9.25-32.66S148.91,210.75,148.91,210.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.26,224.11c0,4-.13,12.58,1.74,15.92s-.87,4.74-.87,4.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.45,297.85l5.22,11.82-37.92,35c-8.58-3.75-1.88-64.15-9.14-86-.35-1-.71-2.15-1.1-3.28a2.88,2.88,0,0,1,1.93-3.68,100.24,100.24,0,0,1,10.8-2.43,105.51,105.51,0,0,1,14.82-1.56c6.43,0,13.8.67,13.8.67s1,.25,1.71,7.06C156.18,261.82,156.77,274.6,155.45,297.85Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.76,250.47s2.45,3.48,10.58,4.52c0,0,4-2.65,2.32-5.87,0,0-1.76-.55-2.14-3.35a13.58,13.58,0,0,1,.75-5.83c.09-.3.2-.62.31-.94l-10.28-6.43S131.92,245.6,126.76,250.47Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.61,236.3s.55,7.35,6.91,9.47a13.58,13.58,0,0,1,.75-5.83C134.52,238,130.61,236.3,130.61,236.3Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.75,251.39s.93-5.9,3.29-6.22c0,0,5.41,4.37,13.25.6,0,0,1.44-.21,1.47,2.51s3.36,2.2,1,7S128.69,261.52,122.75,251.39Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.75,251.39s.93-5.9,3.29-6.22c0,0,5.41,4.37,13.25.6,0,0,1.44-.21,1.47,2.51s3.36,2.2,1,7S128.69,261.52,122.75,251.39Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.12,212.22c8.4,1.43,10.34,6.39,9.48,15.16-1.08,11-4.79,18.23-14.9,14.12C122,235.93,127.17,209.84,141.12,212.22Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.25,226a18.07,18.07,0,0,0,1.85,3.9,2.35,2.35,0,0,1-2.38.57Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.22,224.41c-.1.7-.56,1.2-1,1.14s-.75-.69-.65-1.38.56-1.2,1-1.13S140.32,223.72,140.22,224.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.37,223l1.6-.37S140,223.83,139.37,223Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.86,225.53c-.1.7-.56,1.2-1,1.14s-.76-.69-.66-1.38.56-1.2,1-1.13S149,224.84,148.86,225.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,224.16l1.59-.37S148.67,225,148,224.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.13,218.6a4.43,4.43,0,0,0-3.86.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.7246800000000001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.3,219.29a4,4,0,0,1,3.23,1.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.7246800000000001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.52,224.81s5.11-6.23,5.42-11.66c0,0,17.82-4,15.75,13.08,0,0,4.19-14.73-10.2-17.53S122.56,227,129,234.61C129,234.61,126.35,228.72,129.52,224.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.59,226.82a3.74,3.74,0,0,0-3.39-4c-2.65-.16-4.81,5,1.45,7.37C129.55,230.48,130.23,229.66,130.59,226.82Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.91,215.63s4-4.63.69-8.5-17.29-4.63-22-.5-4.21,6.37-4.21,6.37a29.84,29.84,0,0,0-2.63,14.88c.88,7.87-2.16,12.75-.14,15.25s4,2.64,4,2.64a10.36,10.36,0,0,1,0-5.64c.92-2.5,0-.75,0-.75s1.07,6.5,2.18,7.25a11.66,11.66,0,0,0,3.85,1,20.78,20.78,0,0,1-1.61-9.79c.63-4.88,3.25-9.88,2.63-15.63a15.43,15.43,0,0,1,2.81-10.19S144.45,210.88,148.91,215.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.91,214.13a4.88,4.88,0,0,0,3.22-5.14c-.38-4-7.82-6.42-12-5.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.58,212.5s-5.16,7.36-4.68,15.77-2.4,11-1.52,13.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.27,231.5s.31,2.33,5,2.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.42,296.18s5.75,1.15,6.83,1.49a57.74,57.74,0,0,1,9.22,6c1.36,1.34-7.47,3.51-9.22,3s-4.91-4.25-4.91-4.25l-6.34-1Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.44,251.69s-4.77,1.64-5.77,15.64,1.19,37,11,43.34,45.36-7,45.36-7,1.55-7.26,0-8.84c-6.42-6.55-28.69-.58-36.47-4.21S124.56,258.72,114.44,251.69Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.44,251.69s-4.77,1.64-5.77,15.64,1.19,37,11,43.34,45.36-7,45.36-7,1.55-7.26,0-8.84c-6.42-6.55-28.69-.58-36.47-4.21S124.56,258.72,114.44,251.69Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165 294.83 163.83 304.09 168.83 304.31 171 296.18 165 294.83",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165 294.83 163.83 304.09 168.83 304.31 171 296.18 165 294.83",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,305v2.94c0,.75-.89,1.06-1.63,1.06H164.66c-.75,0-1.66-.31-1.66-1.06V305Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,305v2.94c0,.75-.89,1.06-1.63,1.06H164.66c-.75,0-1.66-.31-1.66-1.06V305Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,305v2.94c0,.75-.89,1.06-1.63,1.06H184.65c-.76,0-1.65-.31-1.65-1.06V305Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.82,274.5l-7,31.7a2.37,2.37,0,0,1-2.27,1.8H187.39a1.54,1.54,0,0,1-1.44-2l7-31.46A2.19,2.19,0,0,1,195.2,273h38.18C234.41,273,235.05,273.46,234.82,274.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.82,274.5l-7,31.7a2.37,2.37,0,0,1-2.27,1.8H188.69a1.55,1.55,0,0,1-1.45-2l7-31.46A2.19,2.19,0,0,1,196.5,273h36.88C234.41,273,235.05,273.46,234.82,274.5Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,290.61h0c0,2.71-2.91,4.92-5,4.92s-3.4-2.21-2.79-4.92,2.73-4.83,4.82-4.91c-.61,2.71.69,4.91,2.81,4.91Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bubble-1--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.33,153H117.77a5.64,5.64,0,0,0-5.77,5.44v22a5.74,5.74,0,0,0,5.77,5.56h17.4l3.09,7.84,3.09-7.84h17a5.65,5.65,0,0,0,5.67-5.56v-22A5.55,5.55,0,0,0,158.33,153Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.33,153H117.77a5.64,5.64,0,0,0-5.77,5.44v22a5.74,5.74,0,0,0,5.77,5.56h17.4l3.09,7.84,3.09-7.84h17a5.65,5.65,0,0,0,5.67-5.56v-22A5.55,5.55,0,0,0,158.33,153Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119 175.5 130.63 167 134.25 168 139.13 165 146.91 167.5 156 159.5 156 177 119 177 119 175.5",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119 162 119 177 156 177 156 163 144.16 172 139.13 167.79 127.83 173 120 176 120 162 119 162",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Line--inject-16"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 324,
    y1: 244,
    x2: 324,
    y2: 246.5,
    style: {
      fill: "none",
      stroke: "#2DAF8E",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 324,
    y1: 249.43,
    x2: 324,
    y2: 287.03,
    style: {
      fill: "none",
      stroke: "#2DAF8E",
      strokeLinejoin: "round",
      strokeWidth: 2,
      strokeDasharray: "4.883720874786377,2.930232524871826"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "324 288.5 324 291 321.5 291",
    style: {
      fill: "none",
      stroke: "#2DAF8E",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.61,
    y1: 291,
    x2: 242.95,
    y2: 291,
    style: {
      fill: "none",
      stroke: "#2DAF8E",
      strokeLinejoin: "round",
      strokeWidth: 2,
      strokeDasharray: "4.819277286529541,2.891566276550293"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 241.5,
    y1: 291,
    x2: 239,
    y2: 291,
    style: {
      fill: "none",
      stroke: "#2DAF8E",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324,
    cy: 241.03,
    r: 3.62,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239,
    cy: 291,
    r: 3.62,
    style: {
      fill: "#2DAF8E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character-2--inject-16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 74,
    width: 229,
    height: 159,
    rx: 6.3,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 74,
    width: 229,
    height: 159,
    rx: 6.3,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 100,
    width: 229,
    height: 104,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 100,
    width: 229,
    height: 104,
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432 175 432 153 428 153 428 126 423 126 423 153 414 153 414 193 396 193 396 153 364 153 364 193 348 193 348 195 333 195 333 155 327 155 327 178 312 178 312 171 285 171 285 149 281 149 281 122 276 122 276 149 267 149 267 189 249 189 249 149 217 149 217 189 209 189 209 204 348 204 372 204 438 204 438 175 432 175",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432 175 432 153 428 153 428 126 423 126 423 153 414 153 414 193 396 193 396 153 364 153 364 193 348 193 348 195 333 195 333 155 327 155 327 178 312 178 312 171 285 171 285 149 281 149 281 122 276 122 276 149 267 149 267 189 249 189 249 149 217 149 217 189 209 189 209 204 348 204 372 204 438 204 438 175 432 175",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 120,
    width: 40,
    height: 84,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 128,
    width: 40,
    height: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 136,
    width: 40,
    height: 1,
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 159,
    width: 40,
    height: 1,
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 167,
    width: 40,
    height: 1,
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 175,
    width: 40,
    height: 1,
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 183,
    width: 40,
    height: 1,
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 157,
    width: 39,
    height: 47,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 165,
    width: 39,
    height: 1,
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 173,
    width: 39,
    height: 1,
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 181,
    width: 39,
    height: 1,
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 141,
    width: 40,
    height: 63,
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 149,
    width: 40,
    height: 1,
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 166,
    width: 40,
    height: 1,
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 189,
    width: 40,
    height: 1,
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 197,
    width: 40,
    height: 1,
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 120,
    width: 40,
    height: 84
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 157,
    width: 39,
    height: 47
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 141,
    width: 40,
    height: 63
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M416.33,233H342l14.55-77.27a9.49,9.49,0,0,1,9.32-7.73h55a9.48,9.48,0,0,1,9.32,11.24Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.33,233H342l14.55-77.27a9.49,9.49,0,0,1,9.32-7.73h55a9.48,9.48,0,0,1,9.32,11.24Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.33,233H397l14.56-77.27a9.48,9.48,0,0,1,9.32-7.73h0a9.48,9.48,0,0,1,9.32,11.24Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.5,183s-1.11,3-2.88,6.84c-2.82,6.15-7.31,14.45-11.62,16.1-3.53,1.36-12.4,1.61-20.32,1.53S307,207,307,207v-6l26-6.93s13.72-24.76,21.83-28.43Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.62,189.84c-2.82,6.15-7.31,14.45-11.62,16.1-3.53,1.36-12.4,1.61-20.32,1.53,0,0,12.67-6.86,16.32-10.47,4.05-4,14.48-19.92,14.48-19.92Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.05,160.38c2.43-1.11,16.95-1.11,16.95-1.11V170l-20.5,3.83S364.18,162.58,369.05,160.38Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,233c-.41-9.29-4.32-39.57,1-68.85a85.52,85.52,0,0,0-12.47-1.24,158.28,158.28,0,0,0-18.35.4,80.14,80.14,0,0,0-12.36,2.52s-5.74,21.33.65,67.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.56,204.56c3.66-.81,8.09-4.36,11.71-7.86,0-6.23.3-12.86,1-19.62C391.12,184.67,377.24,206,383.56,204.56Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.31,142.34c-1,5.93-1.95,16.77,2.26,20.62a18.91,18.91,0,0,1-13.31,6c-7.56.33-5-5.64-5-5.64,6.56-1.72,6.28-6.6,5-11.16Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.81,146.36l-6.55,5.84a18.76,18.76,0,0,1,.64,3.24c2.51-.42,5.9-3.25,6.11-5.89A8.78,8.78,0,0,0,378.81,146.36Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,127c3.27,2.22,1.78,6-5.63,11.88-3-3.9-3.51-11.48-1.11-13.38S366.09,125.08,369,127Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,133.1c-.36,8-.17,12.71-4.13,16.88-6,6.28-15.9,2.79-18-5.17-1.82-7.14-.94-19,6.83-22.35A10.93,10.93,0,0,1,383,133.1Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.13,135.5c0,.65-.33,1.18-.75,1.19s-.77-.51-.78-1.16.31-1.18.74-1.2S371.08,134.86,371.13,135.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.73,135.64c0,.65-.33,1.18-.75,1.19s-.78-.51-.79-1.17.32-1.19.75-1.19S363.72,135,363.73,135.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.15,135.9a23.4,23.4,0,0,1-3,5.62,3.74,3.74,0,0,0,3.12.53Z",
    style: {
      fill: "#a24e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.11,133.13a.43.43,0,0,0,.25,0,.4.4,0,0,0,.07-.54,3.81,3.81,0,0,0-3.14-1.53.37.37,0,0,0-.35.39v0a.39.39,0,0,0,.41.34h0a3,3,0,0,1,2.47,1.23A.36.36,0,0,0,373.11,133.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.32,133.2a.42.42,0,0,0,.35-.22,3,3,0,0,1,2.12-1.77.39.39,0,0,0,.32-.44.38.38,0,0,0-.42-.32,3.78,3.78,0,0,0-2.71,2.21.38.38,0,0,0,.18.5h0A.47.47,0,0,0,360.32,133.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.73,126.07c-3.72,1.35-3.19,5.37,2.55,12.89,3.88-3.05,6.22-10.28,4.36-12.7S383,124.9,379.73,126.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,139.44a7.62,7.62,0,0,1-3.55,4.61c-2.32,1.32-4.12-.61-4-3.13.1-2.28,1.43-5.71,4-6S387.59,137.05,387,139.44Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.09,127.2s1.68-4.7-3.85-8.57c-4.77-3.35-17.49-2.88-21.05,1.12a14.56,14.56,0,0,0-3.44,9.13l1.94-3-.53,3.75,5.18-4-1.61,4s5.34-.75,8-3.75l-1.36,2.72s3.27.4,7.64-2.85c0,0-3.23,3.75,1.07,6S387.09,127.2,387.09,127.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.26,143.38a5.6,5.6,0,0,1-5.26,2.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.76,233c-.64-19.11-1.81-55.89-1.72-68.85,0,0-7.94-1.42-11.41-1.2s-9.27,2.38-9.27,2.38S377.23,206.51,381,233Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.76,233c-.64-19.11-1.81-55.89-1.72-68.85,0,0-7.94-1.42-11.41-1.2s-9.27,2.38-9.27,2.38S377.23,206.51,381,233Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.57 159.27 377.37 165.33 380.33 172 389.09 162.81 385.57 159.27",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.31,233c4.76-62.34,10.67-67.37,10.67-67.37l-1.16-3.49-12,3.69c-5.58,8.2-6.72,49.53-6.95,67.17Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.31,233c4.76-62.34,10.67-67.37,10.67-67.37l-1.16-3.49-12,3.69c-5.58,8.2-6.72,49.53-6.95,67.17Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,200.41s-15.08-.46-16.62-.62-8.09-3.84-9.47-4-5.12,5.68-5.58,7.06,10.42,5.07,11.5,4.92a19.92,19.92,0,0,0,3.56-1.32L346,208.39Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,164.15c14.09,5.08-10.64,43.23-18.32,47.16S333,207,333,207l1.53-7.89s34.52.88,37.7.08,10.74-17.07,15.09-24.75A24.57,24.57,0,0,1,398,164.15Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.33 198 335.33 208.68 331.64 207.32 333.02 198 337.33 198",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.33 198 335.33 208.68 331.64 207.32 333.02 198 337.33 198",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.62,160.5s-5.85,4-5.48,7.83l4.84-2.7S367.24,162.33,368.62,160.5Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 206.58,
    width: 94.01,
    height: 4.85,
    rx: 1.08,
    transform: "translate(639.01 418.01) rotate(180)",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,207.53v2.7c0,.6,0,.77.57.77h91.86c.6,0,1.57-.17,1.57-.77v-2.7c0-.59-1-.53-1.57-.53H273.57C273,207,273,206.94,273,207.53Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,207.53v2.7c0,.6.31.77.9.77h36.53c.6,0,1.57-.17,1.57-.77v-2.7c0-.59-1-.53-1.57-.53H328.9C328.31,207,328,206.94,328,207.53Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,203v2.94c0,.75.76,1.06,1.5,1.06h58.71c.75,0,1.79-.31,1.79-1.06V203Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,203v2.94c0,.75.76,1.06,1.5,1.06h58.71c.75,0,1.79-.31,1.79-1.06V203Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,203v2.94c0,.75.76,1.06,1.5,1.06h38.72c.75,0,1.78-.31,1.78-1.06V203Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.05,172.5l7,31.7a2.39,2.39,0,0,0,2.27,1.8h38.18a1.53,1.53,0,0,0,1.43-2l-7-31.46a2.18,2.18,0,0,0-2.27-1.55H271.49C270.46,171,269.82,171.46,270.05,172.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.05,172.5l7,31.7a2.39,2.39,0,0,0,2.27,1.8h38.18a1.53,1.53,0,0,0,1.43-2l-7-31.46a2.18,2.18,0,0,0-2.27-1.55H271.49C270.46,171,269.82,171.46,270.05,172.5Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.05,172.5l7,31.7a2.39,2.39,0,0,0,2.27,1.8h36.88a1.54,1.54,0,0,0,1.44-2l-7-31.46a2.19,2.19,0,0,0-2.27-1.55H271.49C270.46,171,269.82,171.46,270.05,172.5Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.03 189.73 296.38 186.79 286.44 186.79 287.09 189.73 297.03 189.73",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250.28,157.46a9.84,9.84,0,0,1-.17,1.78L236.22,233H215.3a6.3,6.3,0,0,1-6.3-6.3V148h31.79A9.48,9.48,0,0,1,250.28,157.46Z",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.28,157.46a9.84,9.84,0,0,1-.17,1.78L236.22,233H215.3a6.3,6.3,0,0,1-6.3-6.3V148h31.79A9.48,9.48,0,0,1,250.28,157.46Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.22,233h-19.3l14.56-77.27a9.47,9.47,0,0,1,9.31-7.73h0a9.48,9.48,0,0,1,9.32,11.24Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bubble-2--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.64,95H321.08C318,95,315,97.37,315,100.44v22c0,3.07,3,5.56,6.08,5.56h16.76l13.73,7.84L346,128h3.69a5.39,5.39,0,0,0,5.36-5.56v-22A5.29,5.29,0,0,0,349.64,95Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.97,
    cy: 111.23,
    r: 11.23,
    transform: "translate(149.76 411.69) rotate(-76.72)",
    style: {
      fill: "#2DAF8E"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.97,
    cy: 111.23,
    r: 11.23,
    transform: "translate(149.76 411.69) rotate(-76.72)",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "329.67 110.3 334 115.42 341 106",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorking);
export default __webpack_public_path__ + "static/media/working.4a6e27fe54b736cad2c46ee9b534e83b.svg";
export { ForwardRef as ReactComponent };